import React, { useContext, useEffect, useState } from 'react';
import { SaleItemsContext } from '../index';
/**
 * コピーライト一覧を返す
 */
const createCopyrightList = (saleItemListMap, latestItemListMap) => {
    // 2つのマップからコピーライトだけを抽出して配列で返す
    return [
        ...getCopyrightList(saleItemListMap),
        ...getCopyrightList(latestItemListMap)
    ];
};
/**
 * コピーライト情報を連結して返す
 */
const getCopyrightList = (itemListMap) => {
    const result = [];
    for (const key of Object.keys(itemListMap)) {
        for (const item of itemListMap[key]) {
            if (item.copyright) {
                result.push(item.copyright);
            }
        }
    }
    return result;
};
/**
 * コピーライト要素を生成して返す
 */
const createCopyrightElements = (copyrightList) => {
    if (copyrightList.length === 0) {
        return null;
    }
    return copyrightList.map((copyright, index) => {
        return (React.createElement("span", { key: index }, copyright));
    });
};
const Copyright = () => {
    const [saleItemsState] = useContext(SaleItemsContext);
    const [copyrightList, setCopyrightList] = useState([]);
    useEffect(() => {
        if (saleItemsState && saleItemsState.saleItems && saleItemsState.latestItems) {
            // コピーライト用の配列データを生成してセット
            setCopyrightList(createCopyrightList(saleItemsState.saleItems, saleItemsState.latestItems));
        }
    }, [
        saleItemsState
    ]);
    return (React.createElement("div", { className: "copyright" },
        React.createElement("div", { className: "base-width gutter" }, createCopyrightElements(copyrightList))));
};
export default Copyright;
